import { render, staticRenderFns } from "./KernelOrderItemsList.vue?vue&type=template&id=3013832c&"
import script from "./KernelOrderItemsList.vue?vue&type=script&lang=js&"
export * from "./KernelOrderItemsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports